import request from '../config/axiosConfig';
import {
  GET_LIST_PERMISSION,
  CREATE_PERMISSION,
  UPDATE_PERMISSION,
  DELETE_PERMISSION,
} from '../constants/apiEndPoint';

const permissionService = {
  getList: async (params) => {
    const { data } = await request({ url: GET_LIST_PERMISSION, method: 'POST', params: params });
    return data?.data;
  },

  create: async (dataBody) => {
    const { data } = await request({ url: CREATE_PERMISSION, method: 'POST', data: dataBody });
    return data;
  },

  update: async (id, dataBody) => {
    const { data } = await request({ url: UPDATE_PERMISSION, method: 'PUT', data: { id, ...dataBody } });
    return data;
  },

  delete: async (id) => {
    const { data } = await request({ url: DELETE_PERMISSION, method: 'DELETE', data: { id } });
    return data;
  },
};

export default permissionService;
